import React, { useEffect, useRef, useState } from 'react';
import { SliderImageWrapper, SliderWrapper } from './CarouselSlider.style';

interface Props {
  images: React.ReactElement[];
  selectedImageIndex: number;
  onClick: (imageIndex: number) => void;
}

const INITIAL_DISPLAYED_IMAGE_INDEX = 1;

export function CarouselSlider({
  images,
  selectedImageIndex,
  onClick,
}: Props): React.ReactElement {
  const imagesRef = useRef<Array<HTMLDivElement>>([]);
  const [scrollToImageIndex, setScrollToImageIndex] = useState(
    INITIAL_DISPLAYED_IMAGE_INDEX,
  );
  useEffect(() => {
    const image = imagesRef.current[selectedImageIndex];
    if (image && scrollToImageIndex !== selectedImageIndex) {
      image.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });

      setScrollToImageIndex(selectedImageIndex);
    }
  }, [selectedImageIndex, scrollToImageIndex, setScrollToImageIndex]);

  return (
    <SliderWrapper>
      {images.map((image, index) => {
        const imageIndex = index + 1;
        return (
          <SliderImageWrapper
            key={index}
            ref={(ele) => {
              imagesRef.current[imageIndex] = ele;
            }}
            isActive={selectedImageIndex === imageIndex}
            onClick={() => onClick(imageIndex)}
          >
            {image}
          </SliderImageWrapper>
        );
      })}
    </SliderWrapper>
  );
}
